import { useEffect, useState } from "react";
import { Link } from 'react-router-dom';
import config, { API_SERVER } from "../../EnvConfig/env_config";
import { AlertBox } from "../Common/Input";
import { post } from "../Common/service";

//custom images

//loder



const ForgotPasswordSlide1 = () => {
   // initial state
    const [user, setUser] = useState({ userCode: '' });
    const [loading, setLoading] = useState(false);
    const [focus, setFocus] = useState('');
    const [alert, setAlert] = useState({ status: '', message: '', focus: '' });
    const StaticToken = config.secret_key;
    const source = 'web'
    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const userCodeFromQuery = params.get('UserCode');

        if (userCodeFromQuery) {
            setUser({ userCode: userCodeFromQuery });
        }
        setFocus("floatingInput")
        document.title = 'Shop4All : Forget Password'
    }, [])

    //Recipe Change Handler
    const HandleChange = (prop, value) => {
        setUser(user => ({ ...user, [prop]: value }))
    }


    //submit button Handler
    const HandleSubmit = () => {
        const data = {
            Token: StaticToken,
            UserCode: user.userCode !== '' ? user.userCode : '',
            Source: source
        }
        setLoading(true)

        post(`${API_SERVER}/api/UserLogin/ForgetPassword`, { ...data }, (res) => {
          
            if (res.status === "SUCCESS") {
                setAlert({ status: res.status, message: res.message, focus: '' });

            }
                if (res.status === "ERROR") {
                    setUser(user => ({ ...user, }))
                    AlertBox(res.status, res.message, res.focus);
                    
                    setLoading(false)
                } else {
                    setLoading(false)
                    
                }
            
        });
    }

    return (
        <>     
            <div className="container-fluid bg-login">
                <div className="row vh-100" >
                    <div className="col-xl-9 col-md-8 d-flex justify-content-center align-items-center flex-column" style={{ background: 'linear-gradient(45deg, #16625e, #28a892)' }}>
                        <img src="./assets/img/login-bg.svg" style={{ width: '50%' }} alt='' />
                        <h2 className="text-white py-4">Welcome Back!</h2>
                    </div>
                    <div className="col-xl-3 col-md-4 px-4 py-5 main-login text-black rounded">
                        <div>
                            <img src="./assets/img/shop4alllogo.png" className='img1' alt="..." style={{ display: "flex", backgroundColor: 'white', width:'200px' }} />
                        </div>
                        <div>
                            <h5 className='fs-5 text-center mt-4'><span style={{ color: 'gray', fontWeight: "bold" }}>Forgot</span> <span style={{ color: '#fdb813', fontWeight: "bold" }}>Password</span></h5>
                            {alert?.status !== 'SUCCESS' && ( 
                                <>
                                    <div className="form-group text-start mb-3">
                                        <label className="form-label mb-1">User Code<span className='required'>*</span></label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            id="floatingInput"
                                            onKeyDown={(e) => {
                                                if (e.key === 'Enter') { setFocus("btnsubmit") };
                                            }}
                                            autoComplete="off"
                                            placeholder="User Code"
                                            name='UserCode'
                                            value={user.userCode}
                                            onChange={(e) => HandleChange('userCode', e.target.value)}
                                        />
                                    </div>
                                    
                                    <button
                                        id="btnsubmit"
                                        className='btn-primary btn w-100'
                                        onClick={HandleSubmit}
                                    >
                                        Reset Forgot Password
                                    </button>
                                    <div className='login-trouble mb-2 mt-4'>
                                        <Link to='/Login' style={{ textDecoration: "underline"}}> Back To Login</Link>
                                    </div>
                                </>
                            )}
                            {alert?.status === 'SUCCESS' && ( 
                                <>
                                <div className="alert alert-success" role="alert">
                                    {alert?.message}
                                </div>
                                    <div className='login-trouble mb-2'>
                                        <button
                                            id="btnsubmit"
                                            className='btn-primary btn w-100'
                                        >
                                            <Link to='/Login'><span style={{ color: "white" }}>Back To Login</span></Link>
                                        </button>
                                    </div>
                                </>
                            )}
                        </div>
                    </div>
                </div>
            </div>
            {/* Forgot Password Form End */}
        </>

    )
}

export default ForgotPasswordSlide1;